document.addEventListener('DOMContentLoaded', () => {
    console.log("ddddd");
    syncFreeGiftWithCart().then(() => {
          // Refresh cart drawer once gift is added
          updateCartDrawer();
        });

});

 /* function updateCartDrawer() {
  fetch('/?sections=cart-drawer')
    .then((res) => res.json())
    .then((data) => {
      const parser = new DOMParser();
      const newHtml = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newCartItems = newHtml.querySelector('cart-items');
      const currentCartItems = document.querySelector('cart-items');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
        document.querySelector('#cart-live-region-text')?.setAttribute('aria-hidden', 'false');
      } else {
        console.warn('⚠️ Could not find cart-items in response or DOM');
      }

     })
    .catch((err) => console.error('❌ Failed to update cart drawer:', err));
} */

function updateCartDrawer() {
  return fetch('/?sections=cart-drawer')
    .then((res) => res.json())
    .then((data) => {
      const parser = new DOMParser();
      const newHtml = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newCartItems = newHtml.querySelector('cart-items');
      const currentCartItems = document.querySelector('cart-items');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
        document.querySelector('#cart-live-region-text')?.setAttribute('aria-hidden', 'false');
      } else {
        console.warn('⚠️ Could not find cart-items in response or DOM');
      }

      // 🟡 Now fetch the updated cart JSON
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      const GIFT_PRODUCT_VARIANT_ID = 50629389910354; // ✅ Set your actual gift variant ID
      let nonGiftQty = 0;

      cart.items.forEach(item => {
        if (item.variant_id !== GIFT_PRODUCT_VARIANT_ID) {
          nonGiftQty += item.quantity;
        }
      });

      const freeShippingBar = document.getElementById('free-shipping-notice');
      if (freeShippingBar) {
        if (nonGiftQty === 0) {
          freeShippingBar.style.display = 'none';
        } else {
          freeShippingBar.style.display = 'block';
        }
      }

const cartItems = document.querySelector('cart-items');
if (cartItems && typeof cartItems.refreshCart === 'function') {
  cartItems.refreshCart();
}


      
    })
    .catch((err) => console.error('❌ Failed to update cart drawer or toggle bar:', err));
}


function syncFreeGiftWithCart() {
  const TARGET_PRODUCT_VARIANT_ID = 50281659728210; // Bundle variant
  const GIFT_PRODUCT_VARIANT_ID = 50261784265042;   // Gift variant

  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let targetQty = 0;
      let giftQty = 0;
      let giftLineItemKeys = [];

      // Loop through cart items
      cart.items.forEach(item => {
        if (item.variant_id === TARGET_PRODUCT_VARIANT_ID) {
          targetQty += item.quantity;
        }
        if (item.variant_id === GIFT_PRODUCT_VARIANT_ID) {
          giftQty += item.quantity;
          giftLineItemKeys.push(item.key);
        }
      });

      // If quantities match, nothing to do
      if (targetQty === giftQty && giftLineItemKeys.length <= 1) {
        return Promise.resolve();
      }

      const updatePromises = [];

      // 🧹 Remove all gift items
      giftLineItemKeys.forEach(key => {
        updatePromises.push(
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          })
        );
      });

      // ➕ Re-add the gift if needed
      if (targetQty > 0) {
        updatePromises.push(
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: GIFT_PRODUCT_VARIANT_ID,
                quantity: targetQty
              }]
            })
          })
        );
      }

      return Promise.all(updatePromises).then(() => {
        console.log(`🎁 Synchronized gift to quantity: ${targetQty}`);
        return updateCartDrawer();
      });
    })
    .catch(err => console.error("❌ Gift sync error:", err));
}
